import { render, staticRenderFns } from "./screening-dialog-result.vue?vue&type=template&id=71921fec&scoped=true"
import script from "./screening-dialog-result.vue?vue&type=script&lang=js"
export * from "./screening-dialog-result.vue?vue&type=script&lang=js"
import style0 from "./screening-dialog-result.vue?vue&type=style&index=0&id=71921fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71921fec",
  null
  
)

export default component.exports